import { TextUnderlineIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Underline = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <TextUnderlineIcon size={Sizes[size]} {...rest} color={fill} />;
};

Underline.displayName = 'Underline';
